module.exports = __webpack_public_path__ + "img/symbol_12.aa1627ae.png";